export default __webpack_public_path__ + "static/media/sanitation.7ea70557.jpg";